// language=GraphQL
export const ALL_DATE_PACKAGE_SETTINGS_QUERY = `query Query {
  datePackageSettings: allRatioDatePackageSettings {
    id
    ratioPackageNo
    price
    availabilityStatus
  }
}`

// language=GraphQL
export const SINGLE_DATE_PACKAGE_SETTINGS_QUERY = `query Query($id: ID!) {
  datePackageSettings: ratioDatePackageSettings(id: $id) {
    id
    ratioPackageNo
    price
    availabilityStatus
  }
}`

// language=GraphQL
export const CREATE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateRatioDatePackageSettingsInput) {
    datePackageSettings: createRatioDatePackageSettings(input: $input) {
      id
      ratioPackageNo
      price
      availabilityStatus
    }
  }`

// language=GraphQL
export const UPDATE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateRatioDatePackageSettingsInput) {
    datePackageSettings: updateRatioDatePackageSettings(input: $input) {
      id
      ratioPackageNo
      price
      availabilityStatus
    }
  }`

// language=GraphQL
export const DELETE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteRatioDatePackageSettingsInput) {
    deleteRatioDatePackageSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteRatioDatePackageSettingsInput) {
    forceDeleteRatioDatePackageSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const DATE_PACKAGE_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravelDates: Boolean = false) {
  groupedDependents: ratioDatePackageSettingsDependents(id: $id) {
    ratioTravelDates @include(if: $withRatioTravelDates) {
      id
      dateNo
      startDate
      endDate
      includesExtension
      json
    }
  }
}`
